import { render, staticRenderFns } from "./RyokinFile.vue?vue&type=template&id=1d57df9e&scoped=true&"
import script from "./RyokinFile.vue?vue&type=script&lang=js&"
export * from "./RyokinFile.vue?vue&type=script&lang=js&"
import style0 from "./RyokinFile.vue?vue&type=style&index=0&id=1d57df9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57df9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
